import { paths } from '@AppRoutes/constants.js';

const historyAndAlertsForTabViewClass = 'u-els-display-none u-els-display-inline@tablet';

export default {
  quickSearch: {
    id: 'general-menu-quick-search',
    label: 'Quick search',
    path: paths.SEARCH,
  },
  queryBuilder: {
    id: 'general-menu-query-builder',
    label: 'Query builder',
    path: paths.ADVANCED,
  },
  results: {
    id: 'general-menu-results',
    label: 'Results',
    path: '#',
  },
  alerts: {
    id: 'general-menu-alerts',
    label: 'Alerts',
    path: paths.ALERTS,
    className: historyAndAlertsForTabViewClass,
  },
  conditions: {
    id: 'general-menu-conditions',
    label: 'Conditions navigator',
    path: paths.CONDITIONS,
  },
  retrosynthesis: {
    id: 'general-menu-retrosynthesis',
    label: 'Retrosynthesis',
    path: paths.RS,
  },
  history: {
    id: 'general-menu-historyNav',
    label: 'History',
    path: paths.HISTORY_RECENT,
    className: historyAndAlertsForTabViewClass,
  },
  historySaved: {
    id: 'general-menu-historyNav',
    label: 'History',
    path: paths.HISTORY_SAVED,
    className: historyAndAlertsForTabViewClass,
  },
};
